// eslint-disable-line no-unused-vars
import momentGenerateConfig from "rc-picker/lib/generate/moment";
import generatePicker from "antd/es/date-picker/generatePicker";

const DatePicker = generatePicker(momentGenerateConfig);
const TimePicker = DatePicker.TimePicker;

export { TimePicker };
export default DatePicker;
